export default __webpack_public_path__ + "static/media/reims5.d4b67ad8.jpg";